import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import DropdownVoucherDynamicInput from "../../../../components/Dropdown/DropdownVoucherDynamicInput";
import DropdownForItemLedgerDynamic from "../../../../components/Dropdown/DropdownForItemLedgerDynamic";
import { currencyFormate } from "../../../../components/Date_Formate_Utilitiy/Index";

export const VoucherSalesPurchaseInputRow = ({
  data,
  setData,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  itemData,
  dropList,
  narr_ref,
  itemLedgerData,
  handleDropdownDynamicClick,
  godownLocationItem,
  dynamicInputRef_expenses,
  handleKeyDown,
  isView,
  isItemLoading,
  isGodownLoading,
  isListLoading,
}) => {
  const modal_state = useSelector((state) => state.common.modal_state);

  // Memoize the input handlers
  const getInputHandlers = useCallback(
    (id, field) => ({
      onChange: (e) => handleChange(e, id, field, e.target.value),
      onFocus: (e) => handleFocus(e, id, field, e.target.value),
      onBlur: (e) => handleBlur(e, id, field, e.target.value),
      onKeyDown: (e) => handleKeyDown(e, id, field),
    }),
    [handleChange, handleFocus, handleBlur, handleKeyDown],
  );

  return (
    <div
      className="row m-0 p-0"
      style={{ height: "33vh", overflowY: "scroll" }}
    >
      <div className="col-12">
        <div className="row">
          {data?.data_item?.map((item, index) => {
            console.log(item, "item");
            const itemNameInputHandlers = getInputHandlers(
              item?.id,
              "item_name",
            );
            const godownInputHandlres = getInputHandlers(
              item?.id,
              "godown_location",
            );
            const qtyInputHandles = getInputHandlers(item?.id, "item_qty");
            const rateInputHandlres = getInputHandlers(item?.id, "item_rate");
            const perInputHandles = getInputHandlers(item?.id, "per_unit");
            const amountInputHandlres = getInputHandlers(item?.id, "item_amt");
            return (
              <div
                key={item?.id || `item-${index}`}
                className={`col-12`}
                style={{ height: 19.5, backgroundColor: "transparent" }}
              >
                <div className="row" style={{ height: 19.5 }}>
                  <div
                    className={`col-1 m-0 p-0 ps-1 pe-1 font-weight-bold text-end ${item?.check_open ? "" : ``}`}
                    style={{ width: "3%", height: 19.5 }}
                  >
                    {item?.item_name === "" ? "" : index + 1}
                  </div>
                  <div
                    className={`col-4 m-0  p-0 container_of_voucher_dynamic_input`}
                  >
                    <input
                      type="text"
                      name={`item_name${index}`}
                      ref={(el) => {
                        if (!inputRefs.current[item?.id]) {
                          inputRefs.current[item?.id] = {};
                        }
                        inputRefs.current[item?.id].item_name = el;
                      }}
                      className="voucher_entry_account_input"
                      value={item?.item_name || ""}
                      disabled={isView}
                      {...itemNameInputHandlers}
                    />
                    {modal_state[`item_name${item?.id}`] && (
                      <DropdownVoucherDynamicInput
                        title={"List of Items"}
                        state={modal_state[`item_name${item?.id}`]}
                        data={data}
                        setData={setData}
                        input_value={item?.item_name}
                        input_key={"item_name"}
                        input_id={"item_id"}
                        input_blc={""}
                        rawData={itemData}
                        index={index}
                        rowId={item?.id}
                        modal_id={item?.id}
                        ref={inputRefs.current[item?.id]?.item_name}
                        refs={inputRefs}
                        narr_ref={narr_ref}
                        handleDropdownClick={handleDropdownDynamicClick}
                        isDynamic={true}
                        loading={isItemLoading}
                      />
                    )}
                  </div>

                  <div
                    className={`col-1 font_size p-0 m-0 pe-1 font-weight-bold`}
                    style={{ width: "5%" }}
                  ></div>

                  {item?.item_name !== "" ? (
                    <>
                      {data?.location === "Any" ? (
                        <div className="col-2 m-0 p-0 container_of_voucher_dynamic_input">
                          <input
                            type="text"
                            style={{ textAlign: "left" }}
                            name={`godown_location${index}`}
                            ref={(el) => {
                              if (!inputRefs.current[item?.id]) {
                                inputRefs.current[item?.id] = {};
                              }
                              inputRefs.current[item?.id].godown_location = el;
                            }}
                            className="voucher_entry_account_input"
                            value={item?.godown_location || ""}
                            disabled={isView}
                            {...godownInputHandlres}
                          />
                          {modal_state[`godown_location${item?.id}`] && (
                            <DropdownVoucherDynamicInput
                              title={"List of Godown"}
                              state={modal_state[`godown_location${item?.id}`]}
                              data={data}
                              setData={setData}
                              input_value={item?.godown_location}
                              input_key={"godown_location"}
                              input_id={"godown_location_id"}
                              rawData={godownLocationItem}
                              index={index}
                              rowId={item?.id}
                              modal_id={item?.id}
                              ref={inputRefs.current[item?.id]?.godown_location}
                              handleDropdownClick={handleDropdownDynamicClick}
                              isDynamic={true}
                              loading={isGodownLoading}
                            />
                          )}
                        </div>
                      ) : (
                        <div className="col-2 m-0 p-0 container_of_voucher_dynamic_input"></div>
                      )}

                      {item?.is_unit_available ||
                        parseFloat(item?.item_qty) > 0 ||
                        item?.item_qty !== "" ? (
                        <>
                          <div
                            className={`col-1 m-0 p-0 font-weight-bold container_of_voucher_dynamic_input`}
                          >
                            <input
                              type="text"
                              style={{ textAlign: "right", paddingRight: 5 }}
                              name={`item_qty${index}`}
                              ref={(el) => {
                                if (!inputRefs.current[item?.id]) {
                                  inputRefs.current[item?.id] = {};
                                }
                                inputRefs.current[item?.id].item_qty = el;
                              }}
                              className="voucher_entry_account_input"
                              value={item?.item_qty || ""}
                              disabled={isView}
                              {...qtyInputHandles}
                            />
                          </div>
                          <div
                            className="col-1 m-0 container_of_voucher_dynamic_input p-0"
                            style={{ width: "12%" }}
                          >
                            <input
                              type="text"
                              readOnly
                              //name={`combination_of_units${index}`}
                              style={{ textAlign: "right", paddingRight: 5 }}
                              className="voucher_entry_account__dynamic_input"
                              value={
                                item?.combination_of_units
                                  ? `(${item?.combination_of_units})`
                                  : ""
                              }
                            />
                          </div>

                          {item?.item_qty !== "" ? (
                            <>
                              <div
                                className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                                style={{ width: "8.1%" }}
                              >
                                <input
                                  type="text"
                                  style={{
                                    textAlign: "right",
                                    paddingRight: 5,
                                  }}
                                  name={`item_rate${index}`}
                                  ref={(el) => {
                                    if (!inputRefs.current[item?.id]) {
                                      inputRefs.current[item?.id] = {};
                                    }
                                    inputRefs.current[item?.id].item_rate = el;
                                  }}
                                  className="voucher_entry_account_input"
                                  value={item?.item_rate || ""}
                                  disabled={isView}
                                  {...rateInputHandlres}
                                />
                              </div>
                            </>
                          ) : (
                            <div
                              className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                              style={{ width: "8.1%" }}
                            ></div>
                          )}

                          {data?.data_item[index]?.item_qty !== "" ? (
                            <>
                              <div
                                className="col-1 m-0 container_of_voucher_dynamic_input  p-0 position-relative"
                                style={{ width: "5%" }}
                              >
                                <input
                                  type="text"
                                  style={{ textAlign: "left" }}
                                  name={`per_unit${index}`}
                                  ref={(el) => {
                                    if (!inputRefs.current[item?.id]) {
                                      inputRefs.current[item?.id] = {};
                                    }
                                    inputRefs.current[item?.id].per_unit = el;
                                  }}
                                  className="voucher_entry_account_input"
                                  value={item?.per_unit || ""}
                                  disabled={isView}
                                  {...perInputHandles}
                                />
                                {modal_state[`per_unit${item?.id}`] && (
                                  <DropdownVoucherDynamicInput
                                    custom_class={
                                      "dropdown-content-list-per-unit"
                                    }
                                    title={"Units"}
                                    state={modal_state[`per_unit${item?.id}`]}
                                    data={data}
                                    setData={setData}
                                    input_value={item?.per_unit}
                                    input_key={"per_unit"}
                                    input_id={"per_unit_id"}
                                    rawData={item?.item_units}
                                    index={index}
                                    rowId={item?.id}
                                    modal_id={item?.id}
                                    ref={inputRefs.current[item?.id]?.per_unit}
                                    refs={inputRefs}
                                    narr_ref={narr_ref}
                                    handleDropdownClick={
                                      handleDropdownDynamicClick
                                    }
                                    isDynamic={true}
                                    loading={false}
                                  />
                                )}
                              </div>
                            </>
                          ) : (
                            <div
                              className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                              style={{ width: "5%" }}
                            ></div>
                          )}
                        </>
                      ) : (
                        <div className="col-3" style={{ width: "31.8%" }}></div>
                      )}

                      <div
                        className={`col m-0 p-0 border_2_1px_left container_of_voucher_dynamic_input`}
                      >
                        <input
                          type="text"
                          style={{ textAlign: "right", paddingRight: 5 }}
                          name={`item_amt${index}`}
                          ref={(el) => {
                            if (!inputRefs.current[item?.id]) {
                              inputRefs.current[item?.id] = {};
                            }
                            inputRefs.current[item?.id].item_amt = el;
                          }}
                          className="voucher_entry_account_input"
                          value={item?.item_amt || ""}
                          disabled={isView}
                          {...amountInputHandlres}
                        />
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            );
          })}

          {data?.sale_ledger_data?.map((item1, index1) => {
            const ledgerAccountInputHandlers = getInputHandlers(
              item1?.id,
              "ledger_account",
            );
            const ledgerAmountInputHandlers = getInputHandlers(
              item1?.id,
              "ledger_amount",
            );
            return (
              <div
                key={`ledger-${index1}`}
                className={`col-12`}
                style={{ height: 19.5, backgroundColor: "transparent" }}
              >
                <div className="row" style={{ height: 19.5 }}>
                  {/* Sr spacer — same 3% as item rows */}
                  <div className="col-1 m-0 p-0" style={{ width: "3%" }}></div>

                  {/* Ledger name — same col-4 as item Name column */}
                  <div
                    className="col-4 m-0 p-0 container_of_voucher_dynamic_input"
                    style={{ position: "relative" }}
                  >
                    <input
                      type="text"
                      name={`ledger_account${index1}`}
                      ref={(el) => {
                        if (!dynamicInputRef_expenses.current[item1?.id]) {
                          dynamicInputRef_expenses.current[item1?.id] = {};
                        }
                        dynamicInputRef_expenses.current[
                          item1?.id
                        ].ledger_account = el;
                      }}
                      className="voucher_entry_account_input"
                      value={item1?.ledger_account || ""}
                      disabled={isView}
                      {...ledgerAccountInputHandlers}
                    />
                    {modal_state[`ledger_account${item1?.id}`] && (
                      <DropdownForItemLedgerDynamic
                        title={"List of Ledger Account"}
                        state={modal_state[`ledger_account${item1?.id}`]}
                        data={data}
                        setData={setData}
                        input_value={item1?.ledger_account}
                        input_key={"ledger_account"}
                        input_id={"ledger_account_id"}
                        input_blc={""}
                        rawData={itemLedgerData}
                        index={index1}
                        rowId={item1?.id}
                        modal_id={item1?.id}
                        ref={
                          dynamicInputRef_expenses.current[item1?.id]
                            ?.ledger_account
                        }
                        handleDropdownClick={(field, value, index) =>
                          handleDropdownDynamicClick(
                            field,
                            value,
                            index,
                            "expenses",
                          )
                        }
                        loading={isListLoading}
                      />
                    )}
                  </div>

                  {/* Spacer columns — same as item rows (blank after Name) */}
                  <div className="col-1 m-0 p-0" style={{ width: "5%" }}></div>
                  <div className="col-2 m-0 p-0"></div>
                  <div
                    className="col-1 m-0 p-0"
                    style={{ width: "8.1%" }}
                  ></div>
                  <div className="col-1 m-0 p-0" style={{ width: "12%" }}></div>
                  <div
                    className="col-1 m-0 p-0"
                    style={{ width: "8.1%" }}
                  ></div>
                  <div className="col-1 m-0 p-0" style={{ width: "5%" }}></div>

                  {/* Amount — same col as item Amount column, with left border */}
                  {item1?.check || !item1?.ledger_account ? (
                    <div className="col m-0 p-0 border_2_1px_left"></div>
                  ) : (
                    <div className="col m-0 p-0 border_2_1px_left container_of_voucher_dynamic_input">
                      <input
                        type="text"
                        style={{ textAlign: "right", paddingRight: 5 }}
                        name={`ledger_amount${index1}`}
                        ref={(el) => {
                          if (!dynamicInputRef_expenses.current[item1?.id]) {
                            dynamicInputRef_expenses.current[item1?.id] = {};
                          }
                          dynamicInputRef_expenses.current[
                            item1?.id
                          ].ledger_amount = el;
                        }}
                        className="voucher_entry_account_input"
                        value={item1?.ledger_amount || ""}
                        disabled={isView}
                        {...ledgerAmountInputHandlers}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
